import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.12.5/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// import { getUserCLIToken } from "@services/cli";
import { EditionTypeEnum } from "@crusher-shared/types/common/general";
export function getEdition() {
  return process.env.NEXT_PUBLIC_CRUSHER_MODE;
}
export function isWindowCrossOrigin(window) {
  try {
    return !Boolean(window.location.href);
  } catch (_unused) {
    return true;
  }
}
export function nth(d) {
  if (d > 3 && d < 21) return "th";

  switch (d % 10) {
    case 1:
      return "st";

    case 2:
      return "nd";

    case 3:
      return "rd";

    default:
      return "th";
  }
}
export function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  if (!hours) hours = 12; // the hour '0' should be '12'

  if (minutes < 10) minutes = "0" + minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
} // Mainly for generating default test name

export function getShortDate(date) {
  var currentDate = new Date();

  if (currentDate.getUTCFullYear() === date.getUTCFullYear()) {
    var day = date.getUTCDate();
    var monthName = date.toLocaleString("default", {
      month: "long"
    });
    return "".concat(day).concat(nth(day), " ").concat(monthName, " ").concat(formatAMPM(date));
  } // @NOTE: This should never hit but just here a precaution


  return date.getUTCFullYear() + "/" + ("0" + (date.getUTCMonth() + 1)).slice(-2) + "/" + ("0" + date.getUTCDate()).slice(-2) + " " + ("0" + date.getUTCHours()).slice(-2) + ":" + ("0" + date.getUTCMinutes()).slice(-2) + ":" + ("0" + date.getUTCSeconds()).slice(-2);
}
export function getAssetPath(path) {
  if (!path) return path;

  if (getEdition() === EditionTypeEnum.OPEN_SOURCE) {
    return path.includes("localhost:3001/") ? path.replace("localhost:3001/", "output/").replace("http://", "/").replace("https://", "/") : path;
  }

  return path;
}
export var hashCode = function hashCode(s) {
  return s.split("").reduce(function (a, b) {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
};
export function getCollapsedTestSteps(steps) {
  return steps.reduce(function (step, _ref, index) {
    var status = _ref.status;

    if (index == 0) {
      return [{
        type: "show",
        from: 0,
        to: 1
      }];
    }

    if (index == 1) return step;

    if (index + 1 === steps.length) {
      step.push({
        type: "show",
        from: index,
        to: index,
        count: 1
      });
      return step;
    }

    var showStep = status === "REVIEW" || status === "FAILED";
    var type = showStep ? "show" : "hide";
    var lastIndex = step.length - 1;
    var last = step[lastIndex]; // if last and current step same type then expand syntax

    if ((last === null || last === void 0 ? void 0 : last.type) == type) {
      step[lastIndex] = _objectSpread(_objectSpread({}, last), {}, {
        to: index,
        count: index - last.from + 1
      });
    } else {
      step.push({
        type: type,
        from: index,
        to: index,
        count: 1
      });
    }

    return step;
  }, []);
}